import LookUpModel from "./LookUpModel";

export default class SubLevelsModel extends LookUpModel {
    constructor(data: Partial<SubLevelsModel>) {
        super(data);

        this.update(data);
    }
}
